import React from 'react';
import { Provider } from 'mobx-react';

import HeaderState from './stores/HeaderState';
import Header from './components/Header';

const HomeHeader = (railsProps) => {
  const headerState = new HeaderState(railsProps);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Provider headerState={headerState}>
        <Header />
      </Provider>
    </React.Suspense>
  );
};

export default HomeHeader;
